import * as Yup from "yup";

// Interface for the members table form (multiple members)
export interface IMemberFormValues {
  members: IMemberData[];
}

// Interface for individual member data
export interface IMemberData {
  name: string;
  email: string;
  role: string[];
  status: string;
  createdDate: string;
  lastLoginDate: string;
  authMethod: string[];
}

// Interface for add member modal (single member)
export interface IAddMemberFormValues {
  userName: string;
  email: string;
  role: string[];
}

// Validation schema for members table
export const memberValidationSchema = Yup.object().shape({
  members: Yup.array().of(
    Yup.object().shape({
      name: Yup.string().required("Name is required"),
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
      role: Yup.array()
        .of(Yup.string())
        .min(1, "At least one role is required")
        .required("Role is required"),
      status: Yup.string().required("Status is required"),
      createdDate: Yup.string().required("Created date is required"),
      lastLoginDate: Yup.string().required("Last login date is required"),
      authMethod: Yup.array()
        .of(Yup.string())
        .min(1, "At least one authentication method is required")
        .required("Authentication method is required"),
    })
  ),
});

// Validation schema for add member modal
export const addMemberValidationSchema = Yup.object().shape({
  userName: Yup.string().required("User name is required"),
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
  role: Yup.array()
    .of(Yup.string())
    .min(1, "At least one role is required")
    .required("Role is required"),
});

// Initial values for add member modal
export const getMemberFormInitialValues = (): IAddMemberFormValues => ({
  userName: "",
  email: "",
  role: [],
});

// Interface for reset password modal
export interface IResetPasswordFormValues {
  temporaryPassword: string;
}

// Validation schema for reset password modal
export const resetPasswordValidationSchema = Yup.object().shape({
  temporaryPassword: Yup.string()
    .required("Temporary password is required")
    .min(1, "Temporary password cannot be empty"),
});

// Initial values for reset password modal
export const getResetPasswordFormInitialValues = (temporaryPassword: string = ""): IResetPasswordFormValues => ({
  temporaryPassword,
});